import axios from 'axios';
import { toast } from 'react-toastify';
import { request } from '../../../config/helpers/axios-instance';

const errors = {
    apiError: "Something went wrong !",
    somethingWentWrong: "Something went wrong !"
}

export const uploadPrescription = async (files) => {
    const data = new FormData()

    for (let index = 0; index < files.length; index++) {
        let file = files[index];
        data.append('files', file);
    }

    try {
        const res = await axios.post(process.env.REACT_APP_BACKEND_URL + "file/upload/prescription", data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })

        if (res && res.data.success) {
            return res.data.data
        } else {
            toast.error(res.data.error || errors.apiError)
            return null
        }
    } catch (error) {
        toast.error(errors.somethingWentWrong)
        return null
    }
}

export const uploadFilesToLSQ = async (files) => {
    if (!files) {
        toast.error("No files to upload")
        return null
    }

    try {
        const response = await request({
            url: `lsq/admin/uploadFiles`,
            method: 'POST',
            data: {
                files
            }
        })

        if (response.data && response.data.success) {
            toast.success("Files uploaded successfully")
            return response.data?.data
        } else {
            toast.error(response.data.error || errors.apiError)
            return null
        }
    } catch (error) {
        toast.warn(errors.somethingWentWrong)
        return null
    }
}